import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledWrapper = styled(Box)`
  width: 100%;
  overflow: hidden;
`;

export const StyledImage = styled(Box)`
  position: relative;
  width: 100vw;
  height: 100%;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 100% auto;
`;
